import { writable } from 'svelte/store';
import type { Book } from '@legere/storage-manager';

export const tocVisible = writable(false);
export const tocToggle = writable<(() => void) | null>(null);

// Current book being read
export const currentBook = writable<Book | null>(null);
